module.exports = __webpack_public_path__ + "static/media/playonpro.66d6abb0.png";